<template>
  <div class="Page Selfie">

    <video class="Selfie__video" ref="webcam" playsinline />
    <canvas class="Selfie__canvas" ref="imageData" />
    <canvas class="Selfie__canvas" id="t3d" ref="t3d" />

    <keep-alive>
      <Comp v-if="isReady && $route.params.effect != 'NoFx'" ref="effect" :is="$route.params.effect" :found="found" />
    </keep-alive>

    <transition name="Selfie__noeffect">
      <router-link :to="{ params: { effect: 'NoFx' } }" class="Selfie__noeffect" v-if="$route.params.effect != 'NoFx'">
        <img :src="require('./img/mini_close.png')" />
      </router-link>
    </transition>

    <div class="Selfie__circle" :class="{ 'is-gold': $route.params.effect != 'NoFx'}" />

    <div class="Selfie__btns swiper-container" ref="swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide Selfie__slide"
          :class="['is-' + btn]"
          @click="capture(btn, index)" ref="btns"
          v-for="(btn, index) in btns">
          <img :src="require('./img/btn_' + btn.toLowerCase() + '.png')" />
        </div>
      </div>
    </div>

    <Capture ref="capture" :found="found" />

    <transition name="Selfie__loading">
      <div class="Selfie__loading" v-if="!isReady">
        <div class="Selfie__loading-text" v-html="trans('loading')" />
      </div>
    </transition>
  </div>
</template>

<script>
import Aristocrat from './effects/aristocrat/Aristocrat'
import Mrfleur from './effects/mrfleur/Mrfleur'
import FeatherMask from './effects/feather-mask/FeatherMask'
import Capture from '@/components/capture/Capture'
import Swiper from 'swiper'
import Page from '@/core/mixins/Page'
require('swiper/dist/css/swiper.css')

export default {
  name: 'Selfie',
  components: { Aristocrat, Mrfleur, FeatherMask, Capture },
  mixins: [Page],
  translations: {
    fr: { loading: 'Chargement...' },
    en: { loading: 'Loading...' },
  },
  beforeDestroy() {
    if(this.$brfv4.t3d) this.$brfv4.t3d.renderer.dispose()
  },
  data: () => ({
    isReady: false,
    image: null,
    raf: null,
    found: false,
    btns: [ 'NoFx', 'Aristocrat', 'Mrfleur', 'FeatherMask']
  }),
  activated() {
    TweenMax.to(this.$el, 1, { alpha: 1 })
    if(this.$swiper) this.$swiper.update()
    if(this.isReady) this.$brfv4.play()

    if(this.$route.params.effect === undefined)
      this.$router.push({ params: { effect: 'NoFx' } })
  },
  deactivated() {
    TweenMax.to(this.$el, 1, { alpha: 0 })
    this.$brfv4.pause()
  },
  watch: {
    '$route.params.effect'(nv) {
      const index = this.btns.indexOf(nv)
      if(index != -1)
        this.$swiper.slideTo(index)
    }
  },
  mounted() {
    this.initSwiper()
    this.initBrfv4()
  },
  methods: {
    Brfv4Ready(opts) { this.isReady = true },
    setFound(bool) { this.found = bool },
    capture(name, index) {
      if(index == this.$swiper.activeIndex)
        this.$refs.capture.capture()
      else
        this.$swiper.slideTo(index)
    },
    initBrfv4() {
      this.$brfv4 = this.$parent.$brfv4
      this.$brfv4.setOnComponent({
        webcam:  this.$refs.webcam,
        imageData: this.$refs.imageData,
        canvas3d: this.$refs.t3d,
        onReady: this.Brfv4Ready,
        setFound: this.setFound
      })
    },
    initSwiper() {
      this.$swiper = new Swiper(this.$refs.swiper, {
        initialSlide: 1,
        slidesPerView: 'auto',
        spaceBetween: 30,
        centeredSlides: true,
        on: {
          slideChange: () => {
            if(this.$swiper) {
              const index = this.$swiper.activeIndex
              this.$router.push({ params: { effect: this.btns[index] } })
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Selfie
  height 100%
  overflow hidden

  &__slide
    background white
    border-radius 50%
    position relative
    img
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
      width 50px
    &.is-NoFx
      img
        width 28px
    &.is-NoFx.swiper-slide-active
    &.is-NoFx
      background rgba(white, .2)

  &__noeffect
    position absolute
    bottom 40px
    left 50%
    transform translateX(-50%)
    width 25px
    height 25px
    display block
    background rgba(black, .5)
    border-radius 15px
    transition opacity 1s
    z-index 1
    &-enter
    &-leave-active
      opacity 0
    img
      width 10px
      position absolute
      left 50%
      top 50%
      transform translate(-50%, -50%)

  &__loading
    position absolute
    color black
    background-image linear-gradient(to bottom, #d1cbc3 30%, #eae4dd 70%)
    top 0px
    left 0px
    right 0px
    bottom 0px
    z-index 99
    transition opacity 1s
    &-enter
    &-leave-active
      opacity 0
    &-text
      position absolute
      top 50%
      transform translateY(-50%)
      text-align center
      width 100%

  .Capture__btn
    top 70%

  &__video
    display none

  &__canvas
    position absolute
    top 0px
    left 0px

  &__circle
    height 68px
    width 68px
    border 2px solid white
    position absolute
    left 50%
    transform translateX(-50%)
    bottom 74px
    border-radius 50px
    transition border .5s

  &__btns
    position absolute
    bottom 80px
    right 0px
    left 0px
    .swiper-slide
      width 60px
      height 60px

</style>
